/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import AdDistributionView from '@bingads-webui-campaign-legacy/advanced-settings/view/ad-distribution';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useBackboneView } from './use-backbone-view';

const getStyles = (_, { palette = {} }) => ({
  adDistributionContainer: {
    marginBottom: '16px',
    backgroundColor: `${palette.white}`,
    '& .infomark': {
      display: 'none',
    },
    '& .radio a.HelpTopic': {
      textDecoration: 'underline',
    },
    '& .radio > div': {
      marginLeft: '28px',
    },
    '& .expandedImage:before, .expanderImage:before': {
      marginRight: '4px',
    },
    '& .icon-marker': { // private/ui-next/packages/common-styles/src/advanced-settings-section-style.js
      textDecoration: 'none',
      outline: 'none',
      border: 'none',
      color: palette.themePrimary,
      lineHeight: '24px',
      fontSize: 14,
      borderBottom: '1px transparent',

      '&:hover': {
        color: palette.themeDarker,
        borderBottom: `1px solid ${palette.neutralSecondary}`,
      },

      '&:focus': {
        color: palette.themeDarker,
        border: `1px solid ${palette.neutralSecondary}`,
      },
    },
  },
});

// reference: private/campaign-legacy/packages/advanced-settings/view/advancedSettings.js
export const AdDistribution = React.memo((props) => {
  const { setAdDistributionView, options } = props;
  const adDistributionReactWrapper = useBackboneView(useCallback(() => new AdDistributionView({
    ...options,
  }).render(), [options]), setAdDistributionView);

  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classnames(classes.adDistributionContainer)}>
      {adDistributionReactWrapper}
    </div>
  );
});

AdDistribution.propTypes = {
  setAdDistributionView: PropTypes.func.isRequired,
  options: PropTypes.shape({}),
};

AdDistribution.defaultProps = {
  options: {
  },
};
